import { render } from "./survivalreport.vue?vue&type=template&id=45193caf&scoped=true"
import script from "./survivalreport.vue?vue&type=script&lang=js"
export * from "./survivalreport.vue?vue&type=script&lang=js"

import "./survivalreport.vue?vue&type=style&index=0&id=45193caf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45193caf"]])

export default __exports__